// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown {
  width: 200px !important;
  /* Set the width to your desired value */ }

.ant-modal .ant-modal-content {
  padding: 0;
  /* Remove padding */
  border-radius: 0; }

:where(.css-dev-only-do-not-override-1okl62o).ant-modal .ant-modal-content {
  border-radius: 4px !important;
  padding: 25px 37px !important;
  width: 93%; }

:where(.css-dev-only-do-not-override-1okl62o).ant-btn {
  border-radius: 3px !important; }

.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  font-weight: 300 !important;
  font-family: Avenir LT Std, sans-serif !important; }

.ant-modal-confirm-body .ant-modal-confirm-title {
  display: block;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400 !important;
  font-size: 15px;
  line-height: 1.4; }
`, "",{"version":3,"sources":["webpack://./src/components/Modal/index.scss"],"names":[],"mappings":"AAAA;EACI,uBAAuB;EAAE,wCAAA,EAAyC;;AAMlE;EACE,UAAU;EAAE,mBAAA;EACZ,gBAAe,EAAA;;AAGnB;EACE,6BAA4B;EAC9B,6BAA4B;EAC9B,UAAS,EAAA;;AACP;EACE,6BAA4B,EAAA;;AAG9B;EACE,eAAe;EACf,0BAAyB;EACzB,eAAe;EACf,2BAA2B;EAC5B,iDAAiD,EAAA;;AAEpD;EACE,cAAc;EACd,gBAAgB;EAChB,0BAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB,EAAA","sourcesContent":[".custom-dropdown {\r\n    width: 200px !important; /* Set the width to your desired value */\r\n  }\r\n\r\n//  .ant-modal-content {\r\n//       background-color: '#f4f4f4' !important;\r\n//     padding:'0px' !important}\r\n    .ant-modal .ant-modal-content {\r\n      padding: 0; /* Remove padding */\r\n      border-radius:0;\r\n      \r\n  }\r\n  :where(.css-dev-only-do-not-override-1okl62o).ant-modal .ant-modal-content {\r\n    border-radius:4px !important;\r\n  padding:25px 37px !important;\r\nwidth:93%;}\r\n  :where(.css-dev-only-do-not-override-1okl62o).ant-btn {\r\n    border-radius:3px !important;\r\n  }\r\n\r\n  .ant-modal-confirm-body .ant-modal-confirm-content {\r\n    margin-top: 8px;\r\n    color: rgba(0, 0, 0, .65);\r\n    font-size: 13px;\r\n    font-weight: 300 !important;\r\n   font-family: Avenir LT Std, sans-serif !important;\r\n}\r\n.ant-modal-confirm-body .ant-modal-confirm-title {\r\n  display: block;\r\n  overflow: hidden;\r\n  color: rgba(0, 0, 0, .85);\r\n  font-weight: 400 !important;\r\n  font-size: 15px;\r\n  line-height: 1.4;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
